import axios from 'axios';
import { interpretarError } from '../../api/altasCasosApi';

export interface ErrorOportunidad {
  mensaje: string;
  faltas?: string[];
  /** 422 sinFichaEmpleado (R-15, CA-15). */
  sinFicha: boolean;
  /** 409: la oportunidad cambió desde que se abrió (firma P-06). */
  conflicto: boolean;
}

export const AVISO_SIN_FICHA = 'Tu usuario no tiene ficha de empleado en Gescom: puedes consultar, pero no crear ni asignar.';

/** Traduce el error de la API sin volcar detalles de servidor en 5xx (mismo criterio que interpretarError). */
export const errorOportunidad = (error: unknown): ErrorOportunidad => {
  const base = interpretarError(error);
  if (axios.isAxiosError(error) && error.response) {
    const data = error.response.data as { sinFichaEmpleado?: boolean } | undefined;
    if (error.response.status === 422 && data?.sinFichaEmpleado) {
      return { mensaje: AVISO_SIN_FICHA, sinFicha: true, conflicto: false };
    }
    if (error.response.status === 409) {
      return { ...base, sinFicha: false, conflicto: true };
    }
  }
  return { ...base, sinFicha: false, conflicto: false };
};
